import React from 'react'
import propTypes from 'prop-types'

import './Group.scss'

const Group = ({ children, row, column, className }) => {
  return (
    <div
      className={`group ${className ? className : ''} ${
        column ? 'column' : ''
      } ${row ? 'row' : ''}`}>
      {children}
    </div>
  )
}

Group.defaultProps = {
  children: <span>No children</span>,
}

Group.propTypes = {
  children: propTypes.oneOfType([
    propTypes.array,
    propTypes.shape(),
    propTypes.string,
  ]),
  column: propTypes.bool,
  row: propTypes.bool,
  className: propTypes.string,
}

export default Group
